const colors = {
  black: "#000000",
  gray: "#F5F5F5",
  tabGray: "#EAEAEA",
  darkGray: "#979797",
  dark0: "#1A1A1A",
  radioBorder: "#292929",
  radioFill: "#4A90E2",
  messageBorder: "#E0E0E0",
  messageBackground: "#F9F9F9",
  primaryNavy: "#150F56",
  primaryMagenta: "#BF1884",
  white: "#FFFFFF",
  red: "#FF0000",
  statusGreen: "#DBFDD8",
  statusYellow: "#FCFDD8",
  statusRed: "#FDD8D8",
  statusPurple: "#F8D8FD",
  green: "#5DD270",
  lightGreen: "#00FF19",
  yellow: "#D2B95D",
  maroon: "#D25D5D",
  magenta: "#D25DC7",
  mainPink: "#bf1884",
  lightGrey: "#d8d8d8",
  swamp: "#4B8138",
  darkPink: "#9C36C0",
  blue: "#3E55AA",
  purple: "#9C36C0",
  cyan: "cyan",
};

const baseBody = {
  fontFamily: "Poppins",
};

const baseTitle = {
  fontFamily: "Poppins",
};

const typography = {
  titleLarge: {
    ...baseTitle,
    fontSize: "48px",
    letterSpacing: "-0.5px",
    lineHeight: "56px",
    fontWeight: 700,
  },
  titleMedium: {
    ...baseTitle,
    fontSize: "34px",
    letterSpacing: "-0.5px",
    lineHeight: "40px",
    fontWeight: 700,
  },
  titleRegular: {
    ...baseTitle,
    fontSize: "22px",
    letterSpacing: "-0.5px",
    lineHeight: "26px",
    fontWeight: 700,
  },
  titleSmall: {
    ...baseTitle,
    fontSize: "17px",
    letterSpacing: "-0.5px",
    lineHeight: "20px",
    fontWeight: 700,
  },
  bodyMedium: {
    ...baseBody,
    fontSize: "17px",
    letterSpacing: "-0.1px",
    lineHeight: "24px",
  },
  bodyRegular: {
    ...baseBody,
    fontSize: "15px",
    letterSpacing: "-0.1px",
    lineHeight: "22px",
  },
  bodySmall: {
    ...baseBody,
    fontSize: "13px",
    letterSpacing: "-0.1px",
    lineHeight: "20px",
  },
  bodyFinePrint: {
    ...baseBody,
    fontSize: "10px",
    letterSpacing: "-0.07px",
    lineHeight: "15px",
  },
};

const theme = {
  typography,
  colors,
};

export default theme;
